import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-sports-book',
  templateUrl: './sports-book.component.html',
  styleUrls: ['./sports-book.component.css']
})
export class SportsBookComponent extends BaseClass<any> implements OnInit {

  public iframeUrl: any
  public id: any;
  constructor(public service: WebserviceService, public router: Router, protected actRoute: ActivatedRoute) {
    super(document);
    this.id = Number(this.actRoute.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {
    this.getData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.isLoad = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.sportsBook}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.iframeUrl = res.data?.iframe;

        } else if (res.status == false) {
          // this._message.errmessage(res?.error?.message);
          this.iframeUrl = ''
          this.router.navigate([`${this.env.isMobile ? '/m/dashboard' : '/dashboard'}`])
        }
        this.isLoad = false;
      },
      (err) => {
        this.isLoad = false;
        console.log(err);
      });
  }

}

